import { getNotifications, markNotificationAsSeen as markNotificationAsSeenApi } from "../../services/dashboard.services";
import { createContext, useContext } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";

export const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch notifications
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getNotifications();
      setNotifications(response.data || []);
      // Swal.fire({
      //   icon: "success",
      //   text: response.message || "Notifications fetched successfully",
      //   ...SWAL_SETTINGS,
      // });
    } catch (err) {
      setError(err.message || "Failed to fetch notifications");
      // Swal.fire({
      //   icon: "error",
      //   text: err.message || "Failed to fetch notifications",
      //   ...SWAL_SETTINGS,
      // });
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  // this api is marking all the notifications as seen.
  const markNotificationAsSeen = async () => {
    try {
      const response = await markNotificationAsSeenApi();
      console.log(response);
      console.log(response.data, response.success);
      if (response.success) {
        console.log("Notifications marked as seen");
        setNotifications(response.data || []);
      }
    } catch (error) {
      console.error("Error marking notification as seen:", error);
    }
  };

  return <NotificationContext.Provider value={{ notifications, loading, error, fetchNotifications, markNotificationAsSeen }}>{children}</NotificationContext.Provider>;
};

export const useNotification = () => {
  return useContext(NotificationContext);
};
